import { action, makeAutoObservable, runInAction } from 'mobx';
import { DeviceType, ProfileType } from '@ixicare/resources';
import { State } from '~@types/store';
import { getConfigSchema } from '~modules/devices/components/DeviceConfigForm/utils/api';
import { Schema } from '../components/DeviceConfigForm/schema';

class DevicesStore {
  rootStore: State;
  schema: Schema | null = null;
  schemaLoading: boolean = false;
  schemaError: Error | null = null;

  constructor(rootStore: State) {
    makeAutoObservable(this, {
      rootStore: false,
      loadConfigSchema: action.bound,
    });
    this.rootStore = rootStore;
  }

  async loadConfigSchema(profileType: ProfileType, deviceType: DeviceType) {
    if (this.schema || this.schemaLoading) {
      return this.schema;
    }
    this.schemaLoading = true;
    this.schemaError = null;
    try {
      const schema = await getConfigSchema(profileType, deviceType);
      runInAction(() => {
        this.schema = schema;
        this.schemaLoading = false;
      });
      return schema;
    } catch (e) {
      runInAction(() => {
        this.schemaError = e as Error;
        this.schemaLoading = false;
      });
      throw e;
    }
  }

  reset() {
    this.schema = null;
    this.schemaLoading = false;
    this.schemaError = null;
  }
}

export default DevicesStore;
